import { render, staticRenderFns } from "./ShowMassHills.vue?vue&type=template&id=31b51fb2&scoped=true&"
import script from "./ShowMassHills.vue?vue&type=script&lang=js&"
export * from "./ShowMassHills.vue?vue&type=script&lang=js&"
import style0 from "./ShowMassHills.vue?vue&type=style&index=0&id=31b51fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b51fb2",
  null
  
)

export default component.exports